define('app/views/vue/store/alerts',['underscore', 'moment'], function(_, moment) {
    return {
        namespaced: true,
        strict: true,
        state: {
            alerts: {},
            alertTimeout: {}
        },
        mutations: {
            addAlert: function(state, payload) {
                var newState = _.extend({}, state.alerts);
                newState[payload._id] = payload;
                state.alerts = newState;
            },
            removeAlert: function(state, payload) {
                var newState = _.omit(state.alerts, payload._id);
                state.alerts = newState;
            },
            addTimeOut: function(state, payload) {
                var newState = state.alertTimeout;
                newState[payload._id] = payload.timer;
                state.alertTimeout = newState;
            },
            removeTimeOut: function(state, payload) {
                var newState = _.omit(state.alertTimeout, payload._id);
                state.alertTimeout = newState;
            }
        },
        getters: {
            alerts: function(state) {
                return _.values(state.alerts);
            }
        },
        actions: {
            addAlert: function(ctx, payload) {
                if(!payload.type || !payload.message) throw "make sure you provide 'type' and 'message' for the alert.";
                payload._id = moment().unix();
                ctx.commit('addAlert', payload);
                var timer = setTimeout(function(){
                    ctx.dispatch('removeAlert', payload);
                }, 5000);
                ctx.commit('addTimeOut', {_id: payload._id, timer: timer});
                payload.scrollIntoView && document.querySelector('.messages-container').scrollIntoView({behavior: "smooth", block: "end"});
            },
            removeAlert: function(ctx, payload) {
                if(!payload._id) throw "'_id' is required!";
                clearTimeout(ctx.state.alertTimeout[payload._id]);
                ctx.commit('removeAlert', payload);
                ctx.commit('removeTimeOut', payload);
            }
        }
    }
});
